"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_utils_price_format_1 = require("@saatva-bits/pattern-library.utils.price-format");
const selection_hooks_1 = require("../../../selection.hooks");
/**
 * @param {Object} props
 * @param {string} props.productCode
 * @param {string} props.currencySymbol
 * @param {Object.<string, string>} props.updatedAttributes
 * @returns {import('react').ReactNode}
 */
const DropdownPriceDisplay = ({ productCode, currencySymbol = '$', updatedAttributes = {}, }) => {
    const { finalPrice, fullPrice, sku } = (0, selection_hooks_1.useProductPricing)(productCode, updatedAttributes);
    if (!finalPrice && !fullPrice) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("span", { "data-selector": `dropdownPriceDisplay-${sku}`, children: currencySymbol + (0, pattern_library_utils_price_format_1.format)(fullPrice) }) }));
};
DropdownPriceDisplay.propTypes = {
    productCode: prop_types_1.default.string.isRequired,
    updatedAttributes: prop_types_1.default.object,
    currencySymbol: prop_types_1.default.string,
};
exports.default = DropdownPriceDisplay;
//# sourceMappingURL=DropdownPriceDisplay.js.map